import { getPageTitle } from '@global-dax-ad-platform/dax-hooks';
import { withPageTitle } from '@global-dax-ad-platform/dax-utils';
import { Navigate, Route, Routes } from 'react-router';

import DataManagementPage from 'features/DataManagement/pages/DataManagementPage';
import DraftDetailsPage from 'features/Drafts/pages/DraftDetailsPage';
import DraftsPage from 'features/Drafts/pages/DraftsPage';
import EntitiesPage from 'features/Entities/pages/EntitiesPage';
import FrameDetailsPage from 'features/Frames/pages/FrameDetailsPage';
import LinkedAssetDetailsPage from 'features/LinkedAssets/pages/LinkedAssetDetailsPage';
import {
  DATA_MANAGEMENT_PAGE_URL,
  DEFAULT_TITLE,
  DRAFTS_PAGE_URL,
  FRAMES_PAGE_URL,
  LINKED_ASSETS_PAGE_URL,
  ENTITY_PAGE_URL,
} from 'utils/defaults';

const EntitiesPageWithTitle = withPageTitle(EntitiesPage, getPageTitle(DEFAULT_TITLE, 'Entities'));

const DraftsPageWithTitle = withPageTitle(DraftsPage, getPageTitle(DEFAULT_TITLE, 'Drafts'));
const DataManagementPageWithTitle = withPageTitle(
  DataManagementPage,
  getPageTitle(DEFAULT_TITLE, 'Data Managment')
);

const AppRoutes = () => (
  <Routes>
    <Route path="/" element={<Navigate to={ENTITY_PAGE_URL} />} />
    <Route path={ENTITY_PAGE_URL} element={<EntitiesPageWithTitle />} />

    <Route path={DRAFTS_PAGE_URL} element={<DraftsPageWithTitle />} />
    <Route path={DATA_MANAGEMENT_PAGE_URL} element={<DataManagementPageWithTitle />} />
    <Route path={`${FRAMES_PAGE_URL}/:frameId`} element={<FrameDetailsPage />} />
    <Route path={`${LINKED_ASSETS_PAGE_URL}/:linkedAssetId`} element={<LinkedAssetDetailsPage />} />
    <Route path={`${DRAFTS_PAGE_URL}/:draftEntityId`} element={<DraftDetailsPage />} />
    <Route path="*" element={<Navigate to={ENTITY_PAGE_URL} />} />
  </Routes>
);

export default AppRoutes;
